import request from '@/utils/request'

export function updatepwd(params) {
  return request({
    url:'/admin/updatePassword',
    method:'post',
    data:params
  })
}

export function getVerify() {
  return request({
    url:'/admin/getVerify',
    method:'get',
    responseType: 'blob'
  })
}





// WEBPACK FOOTER //
// ./src/api/updatepwd.js